import { render, staticRenderFns } from "./printBagNumber.vue?vue&type=template&id=2bead5f2&scoped=true"
import script from "./printBagNumber.vue?vue&type=script&lang=js"
export * from "./printBagNumber.vue?vue&type=script&lang=js"
import style0 from "./printBagNumber.vue?vue&type=style&index=0&id=2bead5f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bead5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bead5f2')) {
      api.createRecord('2bead5f2', component.options)
    } else {
      api.reload('2bead5f2', component.options)
    }
    module.hot.accept("./printBagNumber.vue?vue&type=template&id=2bead5f2&scoped=true", function () {
      api.rerender('2bead5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/PackagePrinting/printBagNumber.vue"
export default component.exports